"use client";

import React from "react";
import { CircleCheck, MapPin, Phone, Mail } from "lucide-react";
import { Card, CardContent } from "@/components/ui/card";
export default function AgendaTuVisita() {
  const contactInfo = [{
    icon: MapPin,
    label: "Indirizzo",
    value: "Via Lorenzo Ghiberti 21, Padova"
  }, {
    icon: Phone,
    label: "Telefono",
    value: "049 86 40 662"
  }, {
    icon: Mail,
    label: "Email",
    value: "Aziende@worldimmigration.it"
  }];
  return <section data-section-id="222699" id="consulenza-strategica" className="w-full bg-background py-16 md:py-24">
      <div className="container mx-auto px-4 md:px-6">
        <div className="grid gap-12 lg:grid-cols-2 lg:gap-8 items-center">
          
          {}
          <div className="flex flex-col space-y-8">
            <div className="space-y-4">
              <h2 className="font-default text-3xl font-bold tracking-tight sm:text-4xl md:text-5xl text-foreground">
                Consulenza Personalizzata
              </h2>
              <p className="text-lg text-muted-foreground max-w-[600px] font-default">
                Prenota un incontro dedicato per valutare il tuo profilo e individuare le soluzioni più adatte per visti, immigrazione e mobilità internazionale.
              </p>
            </div>

            <div className="flex justify-center items-center min-h-[400px] bg-primary relative">
              <img src="https://wpvc-images.s3.us-east-1.amazonaws.com/images/1663124/img/corporate_consultation_office.png" data-wvc-srcset="https://wpvc-images.s3.us-east-1.amazonaws.com/images/1663124/img/corporate_consultation_office.png-wvc-srcset" data-wvc-sizes="https://wpvc-images.s3.us-east-1.amazonaws.com/images/1663124/img/corporate_consultation_office.png-wvc-sizes" alt="Ufficio World Immigration Delgado" className="w-full h-full object-cover rounded-sm shadow-lg" loading="lazy" />
              <div className="absolute inset-0 bg-gradient-to-t from-primary/80 to-transparent flex flex-col justify-end p-6">
                <div className="bg-background/95 backdrop-blur-md p-4 rounded-sm shadow-lg border border-secondary/30 inline-block w-fit">
                  <h3 className="font-default font-semibold text-foreground mb-2">Orari di Ricevimento</h3>
                  <p className="text-sm text-muted-foreground font-default">Su Appuntamento.</p>
                </div>
              </div>
            </div>

            <div className="grid grid-cols-1 sm:grid-cols-2 gap-4">
              {["Analisi preliminare del profilo", "Strategie corporate su misura", "Coordinamento ed Elaborazione Pratiche Internazionali", "Gestione Documentale Internazionale"].map((benefit, i) => <div key={i} data-index={i} className="flex items-center gap-3 bg-card p-4 rounded-sm border border-border shadow-sm">
                  <CircleCheck className="size-5 text-secondary shrink-0" />
                  <span className="text-sm font-medium text-card-foreground font-default">{benefit}</span>
                </div>)}
            </div>
          </div>

          {}
          <div className="flex flex-col gap-8">
            <Card className="bg-primary border-primary shadow-2xl rounded-sm overflow-hidden">
              <CardContent className="p-6 md:p-8 space-y-6">
                <h3 className="font-default text-xl font-bold text-secondary border-b border-secondary/30 pb-4 text-center">
                  Informazioni di Contatto
                </h3>
                <div className="space-y-6">
                  {contactInfo.map((item, i) => <div key={i} data-index={i} className="flex items-start gap-4">
                      <div className="mt-1 bg-secondary/20 p-2 rounded-sm border border-secondary/40">
                        <item.icon className="size-5 text-secondary" />
                      </div>
                      <div>
                        <p className="text-xs font-medium uppercase tracking-wider text-secondary/80 font-default mb-1">
                          {item.label}
                        </p>
                        <p className="text-secondary font-default font-medium">
                          {item.value}
                        </p>
                      </div>
                    </div>)}
                </div>
              </CardContent>
            </Card>
          </div>

        </div>
      </div>
    </section>;
}